import { render, staticRenderFns } from "./timeoutNotification.vue?vue&type=template&id=9c4c2b56&scoped=true&"
import script from "./timeoutNotification.vue?vue&type=script&lang=js&"
export * from "./timeoutNotification.vue?vue&type=script&lang=js&"
import style0 from "./timeoutNotification.vue?vue&type=style&index=0&id=9c4c2b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4c2b56",
  null
  
)

export default component.exports